import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EventDetailsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="app-container"
      style={{ background: "#f5f5f5", minHeight: "100vh" }}
    >
      <div style={{ padding: "2rem" }}>
        <div
          className="content-card"
          style={{ maxWidth: "800px", margin: "0 auto" }}
        >
          {/* Hero Image */}
          <div
            style={{
              width: "100%",
              height: "300px",
              background:
                "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 300'%3E%3Crect width='800' height='300' fill='%23ff6b35'/%3E%3Ctext x='400' y='150' text-anchor='middle' dy='.3em' fill='white' font-size='24' font-family='serif'%3EThe relevance of Vedas in Today's World%3C/text%3E%3C/svg%3E\") center/cover",
              borderRadius: "12px",
              marginBottom: "2rem",
            }}
          ></div>

          <h1 style={{ color: "#333", marginBottom: "1rem" }}>
            {t("content.relevance")}
          </h1>

          <div style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#0b3a7a", marginBottom: "1rem" }}>
              {t("content.vedaIntro")}
            </h2>
            <p
              style={{ lineHeight: "1.6", color: "#666", marginBottom: "1rem" }}
            >
              {t("content.vedaText")}
            </p>
          </div>

          <div style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#0b3a7a", marginBottom: "1rem" }}>
              {t("content.classification")}
            </h2>
            <p
              style={{ lineHeight: "1.6", color: "#666", marginBottom: "1rem" }}
            >
              {t("content.vedaText")}
            </p>
          </div>

          <div style={{ marginBottom: "2rem" }}>
            <h2 style={{ color: "#0b3a7a", marginBottom: "1rem" }}>
              {t("content.relevance")}
            </h2>
            <p
              style={{ lineHeight: "1.6", color: "#666", marginBottom: "1rem" }}
            >
              {t("content.vedaText")}
            </p>

            {/* Leaves Table */}
            <div style={{ marginTop: "2rem" }}>
              <h3 style={{ color: "#333", marginBottom: "1rem" }}>
                Leaves - Vedas (छात्राणि पत्राणि)
              </h3>

              <div style={{ marginBottom: "1rem" }}>
                <strong>Label:</strong>
                <ul style={{ marginLeft: "1rem" }}>
                  <li>Sanskrit: छात्राणि पत्राणि</li>
                  <li>English: Leaves – The Vedas (Rg, Yajur, Sāma)</li>
                </ul>
              </div>

              <div style={{ marginBottom: "1rem" }}>
                <strong>Design Notes:</strong>
                <ul style={{ marginLeft: "1rem" }}>
                  <li>Each inscribed faintly with "ऋक्", "यजु:", "साम" etc.</li>
                </ul>
                <p>
                  Representing scriptural knowledge as protective covering of
                  the world.
                </p>
              </div>

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "1rem",
                  border: "1px solid #ddd",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5" }}>
                    <th style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Attribute
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Sattva
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Rajas
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Tamas
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Color
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      White / Light Blue
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Red / Orange
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Dark Grey / Black
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Placement
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Top-most branches reaching upward
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Middle-level branches, dynamic
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Lower branches near ground / reflection
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Symbolism
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Wisdom, harmony, purity, spiritual growth
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Passion, desire, restlessness, action
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Ignorance, inertia, darkness
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      English Label
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Sattva - Purity and Wisdom
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Rajas - Activity and Desire
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Tamas - Inertia and Ignorance
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      Sanskrit Label
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      सत्त्व – प्रकाश:
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      रज: – प्रवृत्ति:
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "0.5rem" }}>
                      तम: – प्रज्ञानम्
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <button className="btn-primary" onClick={() => navigate("/home")}>
            {t("common.back")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsPage;
